export default __webpack_public_path__ + "static/media/SleepIllustration.b7ddd0d1.svg";